export default {
      id: "icon-icontop3-usage",
      viewBox: "0 0 78 78",
      url: __webpack_public_path__ + "icons.svg#icon-icontop3",
      toString: function () {
        return this.url;
      }
    }